module.exports = __webpack_public_path__ + "ky.079499c77e9508a498bb.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ky.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ky.svg
// module chunks = styles